import { useRouter } from 'next/router';
import { ReactElement, useMemo } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { t } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import { SearchThemeKeywordContainer } from '../../../domain/search/themekeyword/container/SearchThemeKeywordContainer';
import { createSearchThemeKeywordInput } from '../../../domain/search/themekeyword/util/createSearchThemeKeywordInput';
import { validateSearchThemeKeywordSearchParam } from '../../../domain/search/util/typeguard';
import { CommonMobileHeaderType } from '../../../header/constants';
import { ReactQueryInfiniteType } from '../../../reactQuery/CodegenReactQueryType.type';
import { ReactQueryInfiniteFetcher } from '../../../reactQuery/ReactQueryInfiniteFetcher';
import { useInfiniteSearchThemeKeywordQuery } from '../../../wrapper/searchWrapper';
function ThemeKeywordPage() {
  const {
    query,
    isReady
  } = useRouter();
  const searchThemeKeywordInput = useMemo(() => {
    if (!validateSearchThemeKeywordSearchParam(query)) {
      return;
    }
    return createSearchThemeKeywordInput(query);
  }, [query]);
  if (isReady && !searchThemeKeywordInput) {
    return <div className="font-medium1 text-theme-solid-100 flex-center-full">
        {t('search_result_empty')}
      </div>;
  }
  return <>
      {searchThemeKeywordInput && <>
          <ReactQueryInfiniteFetcher variables={{
        input: searchThemeKeywordInput
      }} reactQuery={useInfiniteSearchThemeKeywordQuery} type={ReactQueryInfiniteType.InfinityScroll} options={{
        initialPageParam: {
          input: {
            ...searchThemeKeywordInput,
            page: 0
          }
        },
        getNextPageParam: lastPage => lastPage.searchThemeKeyword?.isEnd ? undefined : {
          input: {
            ...searchThemeKeywordInput,
            page: (lastPage.searchThemeKeyword?.page || 0) + 1
          }
        }
      }}>
            {data => <SearchThemeKeywordContainer searchThemeKeywordInput={searchThemeKeywordInput} data={data} />}
          </ReactQueryInfiniteFetcher>

          <TrackPageViewContainer trackObj={{
        section: '테마키워드',
        page: '테마키워드',
        actionType: 'Pageview',
        actionName: '테마키워드_화면',
        customProps: {
          user_action: 'pv',
          page_keyword: searchThemeKeywordInput.filterList[0]
        }
      }} />
        </>}
    </>;
}
ThemeKeywordPage.getLayout = function (page: ReactElement) {
  return <Layout title={t('search_theme_keyword')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.FourDepth,
    headerCustomTiaraObject: {
      click: {
        layer1: '상단'
      }
    }
  }} pcLayoutConfig={{
    shouldShowHeader: true
  }}>
      {page}
    </Layout>;
};
export default ThemeKeywordPage;